import { defineComponent as _defineComponent } from 'vue'
import { onBeforeMount, ref } from 'vue'
import { useRouter } from 'vue-router/composables'
import { eventApi } from '@/enitites/event'


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateEventPage',
  setup(__props) {

const router = useRouter()

const loading = ref(true)

async function redirectToCreateEvent() {
  const event = await eventApi.addEvent()

  loading.value = false

  if (!event) {
    await router.push({ name: 'EventsPage' })
    return
  }

  await router.push({ name: 'CreateEventProcessing', params: { id: String(event.id) } })
}

onBeforeMount(() => {
  redirectToCreateEvent()
})

return { __sfc: true,router, loading, redirectToCreateEvent }
}

})